import { Box, Typography } from "@mui/material"
import CustomCard from "./CustomCard"
import luciLogo from "../../../assets/luciLogo2.png"
// import { customTheme as theme } from "../../../theme/customTheme"
import { makeStyles } from "@mui/styles";
import { timeStampToDayString, timeStampToFormatTimeZone, getStageDisplayLabel, convertSecondsToMinutes } from "../../../utils/commonServices";
import "@fontsource/rubik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import StayCurrentLandscapeIcon from '@mui/icons-material/StayCurrentLandscape';
import StayCurrentPortraitIcon from '@mui/icons-material/StayCurrentPortrait';
import FitScreenIcon from '@mui/icons-material/FitScreen';
import MusicNoteOutlinedIcon from '@mui/icons-material/MusicNoteOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import usePermissions from "../../../hooks/usePermissions";
import { PERMISSION } from "../../../constants/constants";
import { updateCreationState } from "../../../redux/eventCreationSlice";
import CustomButton from "../../../components/CustomButton";
import { updateProjectState } from "../../../redux/projectSlice";
import useCustomTheme from "../../../theme/useCustomTheme";
import QuickTurnBadges from "../../../components/QuickTurnBadges";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
 fontWeightNormal:{
  fontWeight: 'normal'
 }, 
fontWeight:{
  fontWeight:600
},
rubik:{
  fontFamily:'Rubik'
}

}));

const EventDetailCard = (props) => {

  const commonReducer = useSelector((state)=> state.root.commonReducer)
  // const event = commonReducer.events?.find((event) => event.id == commonReducer.production_event_id)
  const themeReducer = useSelector((state) => state.root.themeReducer);
  const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [hasPermission] = usePermissions()
  const [theme ] = useCustomTheme()

  const {event} = props
      const [isLandscape, setIsLandscape] = useState(true);
  
    const handleImageLoad = (e) => {
      const { naturalWidth, naturalHeight } = e.target;
      setIsLandscape(naturalWidth >= naturalHeight); // true = wide, false = tall
    };

  // const brandLogo = window.localStorage.getItem('brand_logo_url')
  const brandLogo = themeReducer?.brand_logo

  const eventDetails = commonReducer?.event_details;
  const videoLengthSeconds = eventDetails?.video_length_seconds ?? eventDetails?.video_length;
  const videoOrientation = eventDetails?.video_orientation;
  const OrientationIcon = videoOrientation === 'portrait' ? StayCurrentPortraitIcon : videoOrientation === 'square' ? FitScreenIcon : StayCurrentLandscapeIcon;
  const openingType = eventDetails?.opening_type;
  const openingDisplay =
    openingType === 'text' ? eventDetails?.opening_text
    : openingType === 'logo' ? 'Company Logo (Brand Box)'
    : openingType === 'none' ? 'No Opening'
    : null;

  const classes = useStyles();
  const setPageData = ()=> {
    dispatch(updateCreationState({
        pageData: {
            name : event?.name,
            start_date: event?.start_date,
            end_date: event?.end_date,
            editor_start_date: event?.editor_start_date,
            video_orientation: event?.video_orientation, // landscape | portrait | square
            opening_type: event?.opening_type || 'logo', // logo | text | none (default 'logo' for older projects where it's null)
            opening_text: event?.opening_text || '', // text shown at the start of the video when opening_type === 'text'
            song_type: commonReducer?.event_details?.song_type,
            description: event?.description,
           // quality_options: [1],
            event_type_id: commonReducer?.event_details?.event_type?.id,
            video_length_id: dropdownReducer.video_length?.find((length)=> length.value == event.video_length)?.id,
            video_length_seconds: Number(event?.video_length_seconds ?? event?.video_length) || undefined,
            quick_turn: Boolean(event?.quick_turn),
        }
    }))
}

  const editProjectClickHandler =()=>{
    if(event?.status_type_order < 3){
        setPageData()
       dispatch(updateCreationState({open_form: true, edit: true, event_id: event?.id}))
      }else{
         
      dispatch(updateCreationState({edit_decline_popup:true}))
      }
  }


  return (
    <CustomCard className='rubik' style={{ height:'100%', padding:0 , '& .MuiCardContent-root:last-child':{paddingBottom:0}}} >
      <Box className="rubik" sx={{height:'100%', display:'flex', flexDirection:'column', paddingBottom:{xs:'24px',sm:'24px',md:'24px',lg:'25px',xl:'40px'}}}>
        <Box className="rubik flex j-center a-center" sx={{ width: '100%', marginTop:{xs:'25px',sm:'20px',md:'7%', lg: '7%',xl:'8%'}, marginBottom:{xs:'25px',sm:'20px',md:'3%',lg:'3%',xl:'4%'}}} >
          <Box  width='80%'>
           {/* <img src={brandLogo !== null ? brandLogo : luciLogo}  onClick={()=>navigate('/dashboard', {replace: true})} style={{cursor:'pointer', maxWidth:'70px', maxHeight:'35px'}} /> */}
           {/* {
                brandLogo !== null && <Box textAlign='right'><img src={poweredBy}  width='50%'/></Box> 
            } */}
            <img src={brandLogo !== null ? brandLogo : luciLogo}  onClick={()=>navigate('/dashboard', {replace: true})}   onLoad={handleImageLoad}
        style={{
               maxWidth: isLandscape ? "150px" : "60px",
          maxHeight: !isLandscape ? "80px" : "30px",
        //   width: "auto",
        //   height: "auto",
        //   objectFit: "contain",
          display: "block",
          margin: "0 auto",
        }}/>
            </Box>
           {/* {(hasPermission(PERMISSION.PROJECT.INFO.EDIT) && (event?.status_type_order < 3)) && <EditOutlinedIcon onClick={editProjectClickHandler}  className="flex" sx={{marginLeft:'10px', alignSelf:'flex-end', cursor:'pointer'}}/>} */}
        </Box>

        <Box mt={1} className="rubik" sx={{display:'flex', flexDirection:'column', flexGrow:1, minHeight:0, fontSize: {xs:'10px',md:'12px',lg:'14px',xl:'16px'},  marginRight:{md:'10px',lg:'0.52vw',xl:'0.78vw'}, overflowY:'auto'}}>
          <Box mb={{xs:0.5,md:0.8,   xl:1.3}} sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography sx={{fontWeight:'normal',  fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Lucivideo Name</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px', wordWrap: 'break-word'}, fontFamily:'Rubik'}}>{commonReducer?.event_details?.name}</Typography>
          </Box>
          {(Boolean(commonReducer?.event_details?.quick_turn) || commonReducer?.event_details?.quick_turn_status === 'rejected') && (
            <Box mb={{xs:0.5,md:0.8,   xl:1.3}} sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
              <QuickTurnBadges
                  quickTurn={commonReducer?.event_details?.quick_turn}
                  quickTurnStatus={commonReducer?.event_details?.quick_turn_status}
                  quickTurnRejectionNote={commonReducer?.event_details?.quick_turn_rejection_note}
                  variant="detail"
              />
            </Box>
          )}
          <Box mb={{xs:0.5, md:0.8,  xl:1.3}} sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Status</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{getStageDisplayLabel(commonReducer?.event_details?.status_type)}</Typography>
          </Box>
          <Box mb={{xs:0.5, md:0.8,  xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Event Type</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{commonReducer?.event_details?.event_type?.name}</Typography>
          </Box>
          <Box mb={{xs:0.5,md:0.8,   xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Creation Date</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{timeStampToDayString(commonReducer?.event_details?.start_date)}, {timeStampToFormatTimeZone(commonReducer?.event_details?.start_date)}</Typography>
          </Box>

                    <Box mb={{xs:0.5,md:0.8,   xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Edit Start Date</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{timeStampToDayString(commonReducer?.event_details?.editor_start_date)}, {timeStampToFormatTimeZone(commonReducer?.event_details?.editor_start_date)}</Typography>
          </Box>

          {!!videoLengthSeconds &&
          <Box mb={{xs:0.5,md:0.8,   xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Video Length</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{convertSecondsToMinutes(Number(videoLengthSeconds))}</Typography>
          </Box>}

          {!!videoOrientation &&
          <Box mb={{xs:0.5,md:0.8,   xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Video Orientation</Typography>
            <Box className='flex row a-center' gap={0.6}>
              <OrientationIcon sx={{ fontSize: {xs:'11px',md:'11px',lg:'13px',xl:'18px'}, color: '#878887', flexShrink: 0 }} />
              <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{`${videoOrientation.charAt(0).toUpperCase()}${videoOrientation.slice(1)}`}</Typography>
            </Box>
          </Box>}

          {openingDisplay !== null &&
          <Box mb={{xs:0.5,md:0.8,   xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Opening</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px', wordWrap: 'break-word'}, fontFamily:'Rubik'}}>{openingDisplay}</Typography>
          </Box>}

          {/* <Box mb={2}>
            <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>End Date</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{timeStampToDayString(commonReducer?.event_details?.end_date)}, { timeStampToFormatTimeZone(commonReducer?.event_details?.end_date)}</Typography>
          </Box> */}

        </Box>

        {(hasPermission(PERMISSION.PROJECT.INFO.EDIT)  || ((commonReducer?.event_details?.status_type_order < 3 || ( commonReducer.event_details?.revision?.submitted == false && commonReducer.event_details?.final_video_id == commonReducer.event_details?.revision?.revision_video_id)) ) ) &&
          <Box mt={{xs:1.5,md:2,xl:2.5}} sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, paddingRight:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}}}>
            <CustomCard
              style={{ cursor: 'pointer' }}
              onClick={() => dispatch(updateProjectState({ upload_song_popup: true, audio_popup_tab: 'upload' }))}
            >
              <Box className='flex a-center' gap={{ xs: 0.7, lg: 1 }} sx={{ padding: { xs: '6px 8px', md: '7px 9px', lg: '8px 10px', xl: '12px 14px' } }}>
                <Box className='flex a-center j-center' sx={{ flexShrink: 0, width: { xs: '20px', md: '22px', lg: '25px', xl: '36px' }, height: { xs: '20px', md: '22px', lg: '25px', xl: '36px' }, borderRadius: { xs: '6px', xl: '8px' }, backgroundColor: (theme) => `${theme.palette.info.main}29` }}>
                  <MusicNoteOutlinedIcon sx={{ color: '#08231B', fontSize: { xs: '11px', md: '12px', lg: '13px', xl: '19px' } }} />
                </Box>
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Typography sx={{ color: '#08231B', fontSize: { xs: '8px', md: '8px', lg: '9px', xl: '13px' }, fontFamily: 'Rubik', fontWeight: 700 }}>Audio Files</Typography>
                  <Typography sx={{ color: '#878887', fontSize: { xs: '6.5px', md: '6.5px', lg: '7px', xl: '10px' }, fontFamily: 'Rubik' }}>Music &amp; narration</Typography>
                </Box>
              </Box>
            </CustomCard>
          </Box>}

        {(hasPermission(PERMISSION.PROJECT.INFO.EDIT)  || ((commonReducer?.event_details?.status_type_order < 3 || ( commonReducer.event_details?.revision?.submitted == false && commonReducer.event_details?.final_video_id == commonReducer.event_details?.revision?.revision_video_id)) ) ) &&
          <Box mt={{xs:0.8,md:1, xl:1.3}} sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, paddingRight:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}}}>
            <CustomCard
              style={{ cursor: 'pointer' }}
              onClick={() => dispatch(updateProjectState({ upload_documents_to_editor_popup: true, documents_popup_tab: 'upload' }))}
            >
              <Box className='flex a-center' gap={{ xs: 0.7, lg: 1 }} sx={{ padding: { xs: '6px 8px', md: '7px 9px', lg: '8px 10px', xl: '12px 14px' } }}>
                <Box className='flex a-center j-center' sx={{ flexShrink: 0, width: { xs: '20px', md: '22px', lg: '25px', xl: '36px' }, height: { xs: '20px', md: '22px', lg: '25px', xl: '36px' }, borderRadius: { xs: '6px', xl: '8px' }, backgroundColor: (theme) => `${theme.palette.info.main}29` }}>
                  <DescriptionOutlinedIcon sx={{ color: '#08231B', fontSize: { xs: '11px', md: '12px', lg: '13px', xl: '19px' } }} />
                </Box>
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Typography sx={{ color: '#08231B', fontSize: { xs: '8px', md: '8px', lg: '9px', xl: '13px' }, fontFamily: 'Rubik', fontWeight: 700 }}>My Documents</Typography>
                  <Typography sx={{ color: '#878887', fontSize: { xs: '6.5px', md: '6.5px', lg: '7px', xl: '10px' }, fontFamily: 'Rubik' }}>Docs, PPT, and PDFs</Typography>
                </Box>
              </Box>
            </CustomCard>
          </Box>}

        { ( hasPermission(PERMISSION.PROJECT.INFO.EDIT) &&  (commonReducer?.event_details?.status_type_order < 3) ) &&
          <Box className='flex col j-end a-center'  mt={{xs:1.5, md:2,lg:2.5,xl:3}}>
            <CustomButton
              btnText='Edit Project'
              onClick={editProjectClickHandler}
              type='button'
              color='secondary'
              variant='contained'
              style={{
                borderRadius: '5px',
                border: "none",
                textTransform:'none',
                // backgroundColor:theme.palette.secondary.main,
                }}
              endIcon={<EditOutlinedIcon style={{fontSize:'14px'}} />}
              sx={{fontSize:{xs:'8px',sm:'9px',lg:'11px',xl:'16px'},  fontWeight:600, height:{xs:'18px',sm:'18px',lg:'22px',xl:"36px"}, width: '100%', maxWidth: {xs:'120px', xl:'180px'} , fontFamily:'Rubik'}}
            />
            </Box> }
      </Box>
    </CustomCard>
  )
}

export default EventDetailCard